import script from "./StatsCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatsCards.vue?vue&type=script&setup=true&lang=ts"

import "./StatsCards.vue?vue&type=style&index=0&id=baa42098&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baa42098"]])

export default __exports__